import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose } from 'recompose';

import queryMetaHandler from '../../../utils/queryMetaHandler';
import omitProps from '../../../utils/omitProps';
import { querySelector } from '../../../utils';
import { UNAPPROVED } from '../constants';

export const GetUserMonthBonusesForUserMonth = gql`
  query GetUserMonthBonusesForUserMonthQuery($bonusMonth: String! $userId: Int!) {
    user_month_bonuses_for_user_month(month: $bonusMonth, user_id: $userId) {
      edges {
        node {
          id
          department {
            id
            name
          }
          district {
            id
            name
          }
          approved_bonus_amount
          manager_notes
          state
          total_bonus_opportunity
          net_total_bonus_opportunity
          total_per_diem_amount
          total_billing_revenue
          total_billing_hours: total_billing_time {
            to_hours
          }
          user {
            id
            fullname
            active
          }
        }
      }
    }
  }
`;

const marshallData = ({ data, ownProps }) => {
  const tempResults = querySelector(data, '$.user_month_bonuses_for_user_month.edges[*].node', []);

  /* NOTE: setting default approved_bonus_amount to total bonus opportunity if null */
  const userMonthBonusesForUserMonth = tempResults.map((item) => {
    const copyObject = Object.assign({}, item);

    const { state } = item;
    if (item.user.active) {
      if (state === UNAPPROVED) {
        copyObject.approved_bonus_amount = item.net_total_bonus_opportunity;
      } else {
        copyObject.approved_bonus_amount = item.approved_bonus_amount;
      }
    } else {
      /* Set notes to terminated, disable user */
      copyObject.approved_bonus_amount = 0;
      copyObject.manager_notes = 'terminated';
    }

    copyObject.total_billing_hours = item.total_billing_hours.to_hours;

    return copyObject;
  });

  const [user] = querySelector(data, '$.user_month_bonuses_for_user_month.edges[*].node.user', []);
  return {
    ...ownProps,
    data,
    userMonthBonusesForUserMonth,
    user,
  };
};

const queryGetUserMonthBonusesForUserMonthData = graphql(GetUserMonthBonusesForUserMonth, {
  props: marshallData,
});

export const queryGetUserMonthBonusesForUserMonthGQL = compose(
  queryGetUserMonthBonusesForUserMonthData,
  queryMetaHandler,
  omitProps(['data']),
);
